"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _PageHeader = _interopRequireDefault(require("./PageHeader"));

var _GridModule = _interopRequireDefault(require("./GridModule"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  body: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    margin: "5.5em 3.5em 1.5em 3.5em"
  },
  grid: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: "grid",
    gridTemplateColumns: props => {
      return props.templateCols;
    },
    gridTemplateRows: props => {
      return props.templateRows;
    },
    gridColumnGap: props => {
      return props.colGap;
    },
    gridRowGap: props => {
      return props.rowGap;
    }
  },
  gridItem: {
    gridColumnStart: "auto",
    gridColumnEnd: props => {
      return props.colEnd;
    },
    gridRowStart: "auto",
    gridRowEnd: props => {
      return props.rowEnd;
    },
    position: "relative",
    margin: ".5em"
  }
}));

const MosaicGrid = ({
  localeId,
  items,
  cols = 5,
  rows = 3,
  onCurrentId
}) => {
  const colWidth = 100 / cols;
  const rowHeight = 100 / rows;
  const classes = useStyles({
    templateCols: (colWidth + "% ").repeat(cols),
    templateRows: (rowHeight + "% ").repeat(rows)
  });

  const GridItem = (_ref) => {
    let id = _ref.id,
        cols = _ref.cols,
        rows = _ref.rows,
        index = _ref.index,
        item = _objectWithoutPropertiesLoose(_ref, ["id", "cols", "rows", "index"]);

    const classes = useStyles({
      colEnd: "span " + cols,
      rowEnd: "span " + rows
    });
    return _react.default.createElement("div", {
      className: classes.gridItem
    }, _react.default.createElement(_GridModule.default, _extends({}, item, {
      onClick: () => onCurrentId(id)
    })));
  };

  return _react.default.createElement("div", {
    className: classes.grid
  }, items && items.map((item, index) => {
    const itemProps = (0, _utils.getPreviewItem)(_extends({}, item, {
      index: index,
      localeId: localeId
    }));
    return _react.default.createElement(GridItem, _extends({}, itemProps, {
      key: index
    }));
  }));
};

const PreviewMosaic = ({
  formData,
  formContext,
  width,
  height
}) => {
  const _formData$content = formData.content,
        title = _formData$content.title,
        links = _formData$content.links,
        backgroundImage = _formData$content.backgroundImage;
  const locale = formContext && formContext.currentLocale || formContext && formContext.defaultLocale;
  const localeId = "locale:" + locale;
  const pageTitle = title && title[localeId] || formData.title;
  const onCurrentId = formContext.onCurrentId;
  const classes = useStyles();
  return _react.default.createElement("div", {
    className: classes.root
  }, _react.default.createElement(_PageHeader.default, {
    title: pageTitle
  }), _react.default.createElement("div", {
    className: classes.body
  }, _react.default.createElement(MosaicGrid, {
    localeId: localeId,
    items: links,
    width: width,
    height: height,
    onCurrentId: onCurrentId
  })));
};

var _default = PreviewMosaic;
exports.default = _default;
module.exports = exports.default;